import { detect } from 'detect-browser'
export const browser = detect()
export const browserName = browser && browser.name
export const browserVersion = browser && browser.version && browser.version.split('.')[0]
export const isBrowserBad = (browserName === 'ie' && !(browserVersion === '11' || browserVersion === '10')) || (browserName === 'edge' && browserVersion === '14')
export const isBrowserGoodForPdfViewer = !browserName === 'ie'
export const isIE10 = browserName === 'ie' && browserVersion === '10'

export const logoStyleForIE10 = () => {
  import('./styles/_logo.scss')
}

export const fetchCrossBrowserCSS = () => {
  switch (browserName) {
    case 'ie':
      import('./styles/ie.scss')
      import('./styles/_chat.scss')
      import('./styles/_rushTag.scss')
      if (browserVersion === '10') {
        import('./styles/_logo.scss')
        import('./styles/ie10.scss')
      }
      break
    case 'edge':
      import('./styles/_chat.scss')
      import('./styles/_rushTag.scss')
      break
    case 'firefox':
      import('./styles/_chat.scss')
      break

    default:
      break
  }
}
